module.exports = __webpack_public_path__ + "img/sx.5b091a5e.svg";